import React from 'react';
import { motion } from 'framer-motion';

const FAQ = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <div className="min-h-screen bg-dark-400 pt-24 pb-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero Section */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-6xl font-futuristic font-bold mb-6">
            <span className="gradient-text">❓ FAQ</span>
          </h1>
        </motion.div>

        {/* FAQ Section */}
        <motion.section
          className="mb-16"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <div className="max-w-4xl mx-auto space-y-6">
            {[
              {
                question: "Do all products have warranty?",
                answer: "No. Only specific products include warranty, and it will be shown in the product listing."
              },
              {
                question: "What if my product doesn't work on arrival?",
                answer: "Please contact us within 24 hours with proof (photo/video). We will offer replacement or refund according to our policy."
              },
              {
                question: "Do you test items before shipping?",
                answer: "Yes, all products are checked to ensure quality and functionality before dispatch."
              }
            ].map((faq, index) => (
              <motion.div
                key={index}
                className="card-glass p-6 rounded-lg"
                variants={itemVariants}
              >
                <h3 className="text-lg font-semibold text-white mb-3">Q: {faq.question}</h3>
                <p className="text-gray-300">A: {faq.answer}</p>
              </motion.div>
            ))}
          </div>
        </motion.section>
      </div>
    </div>
  );
};

export default FAQ;
